import { render, staticRenderFns } from "./CardStats.vue?vue&type=template&id=29b245b6&scoped=true&"
import script from "./CardStats.vue?vue&type=script&lang=js&"
export * from "./CardStats.vue?vue&type=script&lang=js&"
import style0 from "./CardStats.vue?vue&type=style&index=0&id=29b245b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b245b6",
  null
  
)

export default component.exports